import React, { useCallback, useState } from "react";
import { Film } from "lucide-react";
import {
  SubtleWrapper,
  ImageUploadSection,
  VideoUploadSection,
  PdfUploadSection,
} from "../../admin/common/form-elements";
import media_info_img from "../../../assets-user/post-property/media_info_img.png";
import RightSideInfoCard from "./RightSideInfoCard";
import { showError } from "../../../utils/toastUtils";
import BackHeader from "./BackHeader";

const Tab3MediaUploads = ({
  formData,
  setFormData,
  onNext,
  onBack,
  onSubmit,
}) => {
  const updateField = useCallback(
    (name, value) => {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    },
    [setFormData]
  );
  useState(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const isLastStep = formData?.propertyType === "land";
  const handleContinue = () => {
    if (!formData.images || formData.images.length < 4) {
      showError("Please upload at least 5 images");
      return;
    }
    if (isLastStep) {
      onSubmit();
    } else {
      onNext();
    }
  };

  const showBrochure = formData.propertyType === "residential";

  return (
    <div className="flex flex-col xl:flex-row relative w-full no-scrollbar px-3 sm:px-4 md:px-6 lg:px-10 ">
      {/* Left Section */}
      <div className="w-full xl:w-[70%] mx-auto">
        {/* Back Button */}
        <BackHeader title="Photos, Videos & Documents" onBack={onBack} />

        <div className="max-w-3xl space-y-6 pb-10 mx-auto">
          {/* IMAGES */}
          <SubtleWrapper
            title="Add Photos of Your Property"
            subtitle="Properties with good photos get 80% more views."
          >
            <ImageUploadSection
              prefillData={formData.images}
              buttonText="Upload Images"
              description="At least 5 images | Max size 5MB | Formats: jpg, png, webp"
              onChange={(uploaded) => {
                console.log("uploaded", uploaded);
                updateField("images", uploaded);
              }}
            />
          </SubtleWrapper>

          {/* VIDEO */}
          <SubtleWrapper
            title="Property Video (Optional)"
            subtitle="Short walkthrough videos attract higher engagement."
          >
            <VideoUploadSection
              prefillData={formData.videoUrl ? [formData.videoUrl] : []}
              onFileSelect={(videoUrl) => updateField("videoUrl", videoUrl)}
              icon={Film}
              buttonText="Upload Video"
              description="Max size 20MB | Formats: mp4, mov | Duration < 10 mins"
            />
          </SubtleWrapper>

          {/* BROCHURE → Only for RESIDENTIAL */}
          {showBrochure && (
            <SubtleWrapper
              title="Upload Brochure (Optional)"
              subtitle="Helps buyers quickly understand full project details."
            >
              <PdfUploadSection
                prefillData={formData.brochureUrl}
                onFileSelect={(url) => updateField("brochureUrl", url)}
              />
            </SubtleWrapper>
          )}

          {/* Continue Button */}
          <div className="flex gap-3 my-8 p-4">
            <button
              className="flex-1 px-6 py-3 border-2 active:scale-[0.98] border-public-highlight text-public-highlight rounded-full font-medium hover:bg-public-highlight/5 transition-all duration-200"
              onClick={handleContinue}
            >
              {isLastStep ? "Submit" : "Continue"}
            </button>
          </div>
        </div>
      </div>

      {/* Right Side Info Block */}
      <div className="xl:w-[30%] mb-10 xl:mb-0 xl:min-h-screen bg-gray-50  sm:px-4  ">
        <div className="xl:sticky top-28">
          <RightSideInfoCard
            image={media_info_img}
            title="Why Visuals Matter?"
            description="High-quality photos and videos dramatically increase buyer attention, helping your property stand out and get inquiries faster."
          />
        </div>
      </div>
    </div>
  );
};

export default Tab3MediaUploads;
